/* api/platform-settings — GET /platform/settings, PATCH /platform/settings/:section */
import { get, patch, post } from './client.js';

export const getAll = () => get('/platform/settings');
export const updateSection = (section, data) => patch(`/platform/settings/${section}`, data);
export const testSmtp = () => post('/platform/settings/smtp/test', {});
